var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class PerfStopwatch {
  constructor() {
    __publicField(this, "resumed", true);
    __publicField(this, "from", performance.now());
    __publicField(this, "_elapsed", 0);
  }
  get elapsed() {
    return this._elapsed;
  }
  pause() {
    this._elapsed += performance.now() - this.from;
    this.resumed = false;
  }
  resume() {
    if (this.resumed)
      return;
    this.resumed = true;
    this.from = performance.now();
  }
}
export {
  PerfStopwatch
};
//# sourceMappingURL=index40.js.map
